import { FC, forwardRef, InputHTMLAttributes, LegacyRef, ReactNode } from 'react';
import { cn } from '@/utils/classNames.ts';
import { InputProps } from 'react-daisyui';
type TextInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'color'> &
  Pick<InputProps, 'size' | 'color' | 'bordered'> & {
    label?: string;
    error?: string;
    wrapperClassName?: string;
    startIcon?: ReactNode;
    endIcon?: ReactNode;
  } & { ref?: LegacyRef<HTMLInputElement> };

const TextInput: FC<TextInputProps> = forwardRef(
  ({ label, error, wrapperClassName, startIcon, endIcon, size = 'md', color, bordered = true, ...args }, ref) => {
    return (
      <div className={cn('form-control w-full', wrapperClassName)}>
        {label ? (
          <label className="label">
            <span className="label-text">{label}</span>
          </label>
        ) : null}
        <label
          className={cn('input flex items-center gap-2', {
            'input-ghost': color === 'ghost',
            'input-primary': color === 'primary',
            'input-secondary': color === 'secondary',
            'input-accent': color === 'accent',
            'input-info': color === 'info',
            'input-success': color === 'success',
            'input-warning': color === 'warning',
            'input-error': error || color === 'error',
            'input-xs': size === 'xs',
            'input-sm': size === 'sm',
            'input-md': size === 'md' || size,
            'input-lg': size === 'lg',
            'input-bordered': bordered,
          })}
        >
          {startIcon ? startIcon : null}
          <input className={cn('grow')} ref={ref} {...args} />
          {endIcon ? endIcon : null}
        </label>
        {error ? (
          <label className="label">
            <span className="label-text-alt text-error-400">{error}</span>
          </label>
        ) : null}
      </div>
    );
  }
);

export default TextInput;
